import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-heads-up-interruption-state',
  templateUrl: './heads-up-interruption-state.component.html',
  styleUrls: ['./heads-up-interruption-state.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeadsUpInterruptionStateComponent {
  @Input()
  interrupted: boolean;
}
